import { render, staticRenderFns } from "./OptimizerManagerTabAccount.vue?vue&type=template&id=525d71c6"
import script from "./OptimizerManagerTabAccount.vue?vue&type=script&lang=js"
export * from "./OptimizerManagerTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports